import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/OrdersApi" );
const customBabcockInstance = new HttpService( "umbraco/api/BabcockOrdersApi" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */

/**
 * Get the order history for the current logged in user
  * @param {string} orgId The ID of the organisation
  * @param {string} webAccountId The ID of the web account
 */
export const loadOrderHistory = ( orgId, webAccountId ) => {
  let urlStr = "LoadOrderHistory?";
  if ( orgId && orgId.length > 0 ) {
    urlStr += `orgId=${orgId}`;
  } else if ( webAccountId && webAccountId.length > 0 ) {
    urlStr += `webAccountId=${webAccountId}`;
  }

  return customBabcockInstance.get( urlStr );
};

/*
* Populates the transaction history for the given order history line
*/
export const getOrderLineTransactionHistory = ( orderHistoryLine ) => {
  return customBabcockInstance.post( "GetOrderLineTransactionHistory", orderHistoryLine );
};

/**
 * Get a list of delegates for the order line
 * @param {string} orderLineId The ID of the order line
 */
export const getOrderLineDelegates = orderLineId => {
  return customBabcockInstance.get( `ListOrderLineDelegates?orderLineId=${orderLineId}` );
};

/**
 * Populate transaction history for a list or order history lines
 * @param {array} orderHistoryLines List of order summary lines
 */
export const getOrderLinesTransactionHistory = ( orderHistoryLines ) => {
  return customBabcockInstance.post( "LoadOrderLinesTransactionHistory", orderHistoryLines );
};

/**
 * Get order header data
 * @param {string} orderId The order header id
 */
/* TODO: Move to eccomerce package with updates */
export const getOrderHeader = orderId => {
  return customBabcockInstance.get( `LoadOrderRefundSummary?orderHeaderId=${orderId}` );
};

/**
 * Get the order line summary data
 * @param {string} orderId The order header id
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */
export const getRefundOrderLine = ( orderId, creditOrderId, creditOrderLineId ) => {
  return instance.get(
    `LoadOrderLineRefundSummary?orderId=${orderId}&creditOrderId=${creditOrderId}&creditOrderLineId=${creditOrderLineId}`
  );
};

/**
 * Post submit order refund data
 * @param {string} orderHeader The order header
 */
export const submitRefund = orderHeader => {
  return instance.post( "SubmitRefund", orderHeader );
};

/**
 * Post cancel refund order line
 * @param {string} creditOrderId The order header id
 * @param {string} creditOrderLineId The order line id
 */
export const cancelRefundOrderLine = ( creditOrderId, creditOrderLineId ) => {
  return instance.post(
    `CancelRefundOrderLine?creditOrderId=${creditOrderId}&creditOrderLineId=${creditOrderLineId}`
  );
};

/*
 * Order line transfer model helper
 */
export const transferOrderLineModel = (
  id,
  bookingStatusCode = encodeURI( null ),
  transferAsCopy = false
) => ( {
  orderLineId: id,
  bookingStatusCode: bookingStatusCode,
  transferAsCopy: transferAsCopy
} );

/**
 * transfers order lines from one header to another (basket to basket)
 * @param {string} fromOrderHeaderId
 * @param {string} toOrderHeaderId
 * @param {Array<Object>} orderLineToTransfer
 */
export const transferOrderLines = ( fromOrderHeaderId, toOrderHeaderId, orderLinesToTransfer ) => {
  return customBabcockInstance.post( "TransferOrderLines", orderLinesToTransfer, {
    fromOrderHeaderId: fromOrderHeaderId,
    toOrderHeaderId: toOrderHeaderId
  } );
};

/**
 * Cancel bookings for 1 or more delegates
 * @param {Array<Guid>} delegateIds List of Delegate IDs to cancel
 * @param {Boolean} creditOrders Whether we should credit the associated orders
 * @param {Number} refundReasonId The resson for refunding
 * @param {String} refundNotes Notes to saved against the refund
 * @returns true, if successful
 */
export const cancelDelegateBookings = ( delegateIds, creditOrders, refundReasonId, refundNotes ) => customBabcockInstance.post( "CancelDelegateBookings", {
  delegateIds,
  creditOrders,
  refundReasonId,
  refundNotes
} );
